import { render, staticRenderFns } from "./SearchEventsList.vue?vue&type=template&id=56c5b7e5&scoped=true&"
import script from "./SearchEventsList.vue?vue&type=script&lang=js&"
export * from "./SearchEventsList.vue?vue&type=script&lang=js&"
import style0 from "./SearchEventsList.vue?vue&type=style&index=0&id=56c5b7e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c5b7e5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VListItem})
